<template>
  <v-card>
    <v-list>
      <v-list-item @click="go('/clients/terms')">
        <v-list-item-title>
          {{label("contracts")}}
        </v-list-item-title>
      </v-list-item>
      <v-list-item @click="handleLogout">
        <v-list-item-title>
          {{label("logout")}}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import ComponentMixin from "@/components/ComponentMixin";

export default {
  mixins: [ComponentMixin],
  type: "organism",
  name: "ClientMenu",
  methods: {
    handleLogout () {
      this.$auth.logout({
        returnTo: `${process.env.VUE_APP_NISHIKA_CONNECT_CLIENT_URL}/clients` || `${window.location.origin}`
      })
    }
  },

}
</script>

<style scoped>

</style>
